import { render, staticRenderFns } from "./PostbackCreate.vue?vue&type=template&id=30780c4a"
import script from "./PostbackCreate.vue?vue&type=script&lang=js"
export * from "./PostbackCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports